import * as types from './actionTypes';
import rest from "../API/api";
//import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';

export function loadTenantsSuccess(tenants) {
    //debugger;
  return {type: types.LOAD_TENANT_SUCCESS, tenants};
}

export function deleteTenantsSuccess(tenants) {
    //debugger;
    return {type: types.DELETE_TENANT_SUCCESS, tenants};
}

export function updateTenantsSuccess(tenants) {
    //debugger;
    return {type: types.UPDATE_TENANT_SUCCESS, tenants};
}

export function addTenantsSuccess(tenants) {
    //debugger;
    return {type: types.ADD_TENANT_SUCCESS, tenants};
}

export function readTenantSuccess(tenant) {
    //debugger;
    return {type: types.READ_TENANT_SUCCESS, tenant};
}


// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
export function loadTenants(user) {
    return function (dispatch) {
        fetch(rest.tenants, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': user.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                //debugger;
                // turn the JSON into a string then into an JS array
               return dispatch(loadTenantsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

//Makes an API call to the gateway which will update the tenant with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function updateTenant(user,tenant) {
    return function (dispatch) {
        //lets define some const. that we can use in the fetch calls below
        //REST API Gateway URLs
        let tempURL = rest.tenants + '/' + tenant.id;
        //Current Tenant record that we will need to update
        const tenantID = tenant.id;
         //Update the main MongoDB record
        fetch(tempURL, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': user.apiKey
            }),
            body: JSON.stringify({
                Userid: tenant.Userid,
                Email: tenant.Email,
                Company: tenant.Company,
                Fname: tenant.Fname,
                Lname: tenant.Lname,
                Address: tenant.Address,
                City: tenant.City,
                State: tenant.State,
                Country: tenant.Country,
                Postal: tenant.Postal,
                Phone: tenant.Phone,
                SubscriptionDate: tenant.SubscriptionDate,
                SubscriptionStatus: tenant.SubscriptionStatus,
                SubscriptionType: tenant.SubscriptionType,
                SubscriptionMultiShopCount: tenant.SubscriptionMultiShopCount,
                SubscriptionPrice: tenant.SubscriptionPrice,
                CustomerXRef: tenant.CustomerXRef,
                Role: tenant.Role,
                Hash: tenant.Hash,
                Salt: tenant.Salt
            }),
        })
            .then(response => response.json())
            .then(data => {
                // turn the JSON into a string then into an JS array
                return dispatch(updateTenantsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will update the tenant with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function addTenant(user,tenant) {
    return function (dispatch) {
        let tempURL = rest.tenants;
        fetch(tempURL, {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': user.apiKey
            }),
            body: JSON.stringify({
                Userid: tenant.Userid,
                Email: tenant.Email,
                Company: tenant.Company,
                Fname: tenant.Fname,
                Lname: tenant.Lname,
                Address: tenant.Address,
                City: tenant.City,
                State: tenant.State,
                Country: tenant.Country,
                Postal: tenant.Postal,
                Phone: tenant.Phone,
                SubscriptionDate: tenant.SubscriptionDate,
                SubscriptionStatus: tenant.SubscriptionStatus,
                SubscriptionType: tenant.SubscriptionType,
                SubscriptionMultiShopCount: tenant.SubscriptionMultiShopCount,
                SubscriptionPrice: tenant.SubscriptionPrice,
                CustomerXRef: tenant.CustomerXRef,
                Role: tenant.Role,
                Hash: tenant.Hash,
                Salt: tenant.Salt
            }),
        })
            .then(response => response.json())
            .then(data => {
                return dispatch(addTenantsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));

    };
}


//Makes an API call to the gateway which will read a tenant with mongoDB_id that matches the one passed on the URL. API call
//will return the current record after the read so we will dispatch a store update with the new records.
export function readTenant(user,id) {
    return function (dispatch) {
        let tempURL = rest.tenants + '/' + id;
        fetch(tempURL, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': user.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {
                debugger;
                // turn the JSON into a string then into an JS array
                return dispatch(readTenantSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}


//Makes an API call to the gateway which will delete the tenant with mongoDB_id that matches the one passed on the URL. API call
//will return the current set of records after the deletion so we will dispatch a store update with the new records.
export function deleteTenant(user,id) {
    return function (dispatch) {
        let tempURL = rest.tenants + '/' + id;
        fetch(tempURL, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json;charset=UTF-8',
                'x-api-key': user.apiKey
            })
        })
            .then(response => response.json())
            .then(data => {

                // turn the JSON into a string then into an JS array
                return dispatch(deleteTenantsSuccess(JSON.parse(JSON.stringify(data))))
            })
            .catch(error => console.error(error));
    };
}

/*

// Functions below handle asynchronous calls.
// Each returns a function that accepts a dispatch.
// These are used by redux-thunk to support asynchronous interactions.
/*
export function loadCourses() {
  return function (dispatch) {
    dispatch(beginAjaxCall());
    return CourseApi.getAllCourses().then(courses => {
      dispatch(loadCoursesSuccess(courses));
    }).catch(error => {
      throw(error);
    });
  };
}

export function saveCourse(course) {
  return function (dispatch, getState) {
    dispatch(beginAjaxCall());
    return CourseApi.saveCourse(course).then(course => {
      course.id ? dispatch(updateCourseSuccess(course)) : dispatch(createCourseSuccess(course));
    }).catch(error => {
      dispatch(ajaxCallError(error));
      throw(error);
    });
  };
}
*/



// WEBPACK FOOTER //
// ./src/actions/tenantActions.js